const useRedirect =
  () =>
  (url: string, options?: { shouldOpenNewTab?: boolean }): void => {
    if (options?.shouldOpenNewTab) window.open(url, '_blank');
    else window.location.href = url;
  };

export default useRedirect;
